import React, { useState } from 'react';
import { useLang } from '../context/LanguageContext';
import { useUser } from '../context/UserContext';
import { loginUser } from '../services/api';

export default function Login() {
  const { t, lang, fontFamily } = useLang();
  const { login } = useUser();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await loginUser({ username, password });
      login(res.data);
    } catch (err: any) {
      if (err.response?.status === 403) {
        // Show the server's clear message (e.g. access restricted to staff).
        setError(err.response?.data?.error || 'הגישה נדחתה');
      } else {
        setError('שם משתמש או סיסמה שגויים');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #7B1FA2 0%, #4A148C 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      direction: 'rtl',
      fontFamily,
    }}>
      <div style={{
        background: 'white',
        borderRadius: 20,
        padding: 40,
        width: '100%',
        maxWidth: 420,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        textAlign: 'center',
      }}>
        {/* Logo */}
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 40, fontWeight: 800, color: '#7B1FA2', letterSpacing: 2 }}>MANARA</div>
          <div style={{ fontSize: 14, color: '#666', marginTop: 4 }}>מכללת מנארה</div>
        </div>

        <h2 style={{ color: '#7B1FA2', fontSize: 20, marginBottom: 24, marginTop: 16 }}>
          {lang === 'ar' ? 'تسجيل الدخول' : 'כניסה למערכת'}
        </h2>

        {error && (
          <div style={{
            background: '#ffebee',
            color: '#c62828',
            padding: '10px 16px',
            borderRadius: 8,
            marginBottom: 16,
            fontSize: 14,
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16, textAlign: 'right' }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 6 }}>
              {t('username')}
            </label>
            <input
              className="form-input"
              style={{ direction: 'ltr', textAlign: 'left' }}
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="admin"
              autoFocus
            />
          </div>
          <div style={{ marginBottom: 24, textAlign: 'right' }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 6 }}>
              {t('password')}
            </label>
            <input
              className="form-input"
              type="password"
              style={{ direction: 'ltr', textAlign: 'left' }}
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••"
            />
          </div>
          <button
            type="submit"
            disabled={loading || !username || !password}
            style={{
              width: '100%',
              padding: '12px 24px',
              background: '#7B1FA2',
              color: 'white',
              border: 'none',
              borderRadius: 10,
              fontSize: 16,
              fontWeight: 600,
              cursor: loading ? 'wait' : 'pointer',
              fontFamily: 'inherit',
              opacity: loading ? 0.7 : 1,
              transition: 'all 0.2s',
            }}
          >
            {loading ? (t('loading')) : (lang === 'ar' ? 'دخول' : 'כניסה')}
          </button>
        </form>
      </div>
    </div>
  );
}
